import { FunctionComponent } from 'react';

export enum ActivityIndicatorSize {
	Normal = 'w-12 h-12',
	Small = 'w-8 h-8',
}

export const ActivityIndicator: FunctionComponent<{
	containerStyle?: string;
	size?: ActivityIndicatorSize;
}> = ({ containerStyle, size = ActivityIndicatorSize.Normal }) => (
	<div
		className={
			containerStyle !== undefined ? containerStyle : 'container mx-auto flex justify-center items-center my-16'
		}
	>
		<div className={`loader ease-linear rounded-full border-4 border-t-4 ${size.valueOf()}`} />
	</div>
);

ActivityIndicator.displayName = 'UI.ActivityIndicator';
